module.exports = __webpack_public_path__ + "static/media/close_icon.7a306470.svg";